// navTranslations.js - 导航栏专用翻译文件
export const navTranslations = {
  zh: {
    // 主导航
    home: '首页',
    features: '功能',
    editor: '在线编辑工具',
    customerService: '联系客服',
    price: '价格',
    login: '登录',
    
    // 功能子菜单
    removeBackground: '一键抠图',
    mattingPoints: '选点抠图',
    imageRefocus: '图像重对焦',
    imageConvert: '图像格式修改',
    ocr: 'OCR识别',
    superResolution: '图片放大',
    imageToSvg: '位图转矢量图',
    aiEraser: 'AI消除笔',
    aiImageEditor: 'AI图像编辑',
    
    // 编辑工具子菜单
    mindMap: '思维导图',
    pptEditor: 'PPT制作',
    aiChat: 'AI聊天',
    
    // 用户信息弹窗
    loggedIn: '已登录',
    remainingQuota: '付费剩余额度',
    dailyFreeQuota: '每日免费额度',
    refreshInfo: '刷新信息',
    loginPage: '登录界面',
    enterInvitationCode: '输入邀请码',
    logout: '退出登录'
  },
  en: {
    // Main navigation
    home: 'Home',
    features: 'Features',
    editor: 'Online Editor',
    customerService: 'Customer Service',
    price: 'Pricing',
    login: 'Login',
    
    // Feature submenu
    removeBackground: 'Remove Background',
    mattingPoints: 'Point Matting',
    imageRefocus: 'Image Refocus',
    imageConvert: 'Image Format',
    ocr: 'OCR Recognition',
    superResolution: 'Image Upscale',
    imageToSvg: 'Bitmap to Vector',
    aiEraser: 'AI Eraser',
    aiImageEditor: 'AI Image Editor',
    
    // Editor tools submenu
    mindMap: 'Mind Map',
    pptEditor: 'PPT Editor',
    aiChat: 'AI Chat',
    
    // User info popup
    loggedIn: 'Logged In',
    remainingQuota: 'Paid Quota Remaining',
    dailyFreeQuota: 'Daily Free Quota',
    refreshInfo: 'Refresh Info',
    loginPage: 'Login Page',
    enterInvitationCode: 'Enter Invitation Code',
    logout: 'Logout'
  },
  ja: {
    // ナビゲーション
    home: 'ホーム',
    features: '機能',
    editor: 'オンライン編集ツール',
    customerService: 'カスタマーサービス',
    price: '料金',
    login: 'ログイン',
    
    // 機能サブメニュー
    removeBackground: '背景除去',
    mattingPoints: 'ポイントマッティング',
    imageRefocus: '画像リフォーカス',
    imageConvert: '画像フォーマット変更',
    ocr: 'OCR認識',
    superResolution: '画像拡大',
    imageToSvg: 'ビットマップからベクター',
    aiEraser: 'AI消しゴム',
    aiImageEditor: 'AI画像編集',
    
    // 編集ツールサブメニュー
    mindMap: 'マインドマップ',
    pptEditor: 'PPTエディター',
    aiChat: 'AIチャット',
    
    // ユーザー情報ポップアップ
    loggedIn: 'ログイン済み',
    remainingQuota: '有料残高',
    dailyFreeQuota: '日次無料枠',
    refreshInfo: '情報更新',
    loginPage: 'ログインページ',
    enterInvitationCode: '招待コード入力',
    logout: 'ログアウト'
  }
};

// 获取导航栏翻译文本的辅助函数
export const getNavTranslation = (lang, key) => {
  const translation = navTranslations[lang]?.[key];
  if (!translation) {
    // 如果找不到翻译，返回中文版本
    return navTranslations.zh[key] || key;
  }
  return translation;
};

// 语言存储管理（专门用于导航栏）
export const NavLanguageStorage = {
  // 保存语言选择，24小时过期
  setLanguage(lang) {
    const expires = new Date().getTime() + (24 * 60 * 60 * 1000); // 24小时后过期
    localStorage.setItem('navLanguage', JSON.stringify({
      lang,
      expires
    }));
  },
  
  // 获取保存的语言
  getLanguage() {
    const saved = localStorage.getItem('navLanguage');
    if (!saved) return null;
    
    try {
      const data = JSON.parse(saved);
      if (new Date().getTime() > data.expires) {
        // 已过期，删除
        localStorage.removeItem('navLanguage');
        return null;
      }
      return data.lang;
    } catch (e) {
      localStorage.removeItem('navLanguage');
      return null;
    }
  },
  
  // 清除语言设置
  clearLanguage() {
    localStorage.removeItem('navLanguage');
  }
}; 